export { default } from '../old-button/loading-button';
export type { LoadingButtonProps, LoadingButtonOwnProps } from '../old-button/loading-button';
